module.exports = __webpack_public_path__ + "static/iot-system-1-44350cb2bfca361678c6f18f97ec13f1.png";